// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_ImportarCsvInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /despesas/importar_csv
 *
 * Batch imports despesas from CSV data.
 */
import type { Despesas_ImportarCsvDespesaInputRow } from './Despesas_ImportarCsvDespesaInputRow'
import { registerContract } from './validate'

export interface Despesas_ImportarCsvInput {
despesas: Despesas_ImportarCsvDespesaInputRow[]
}

registerContract('Despesas_ImportarCsvInput', {
  despesas: {
    type: 'array',
    required: true,
    items: {
      despesa_titulo:                    { type: 'string',  required: false },
      despesa_descricao:                 { type: 'string',  required: false },
      despesa_valor:                     { type: 'number',  required: false },
      despesa_data_vencimento:           { type: 'string',  required: false },
      despesa_data_lancamento:           { type: 'string',  required: false },
      despesa_franquia_id:               { type: 'number',  required: false },
      despesa_usuario_id:                { type: 'string',  required: false },
      despesa_usuario_alvo_id:           { type: 'number',  required: false },
      despesa_categoria_id:              { type: 'number',  required: false },
      despesa_status:                    { type: 'number',  required: false },
      despesa_tipo_mensal:               { type: 'number',  required: false },
      despesa_parcela:                   { type: 'number',  required: false },
      despesa_qtd_parcelas:              { type: 'number',  required: false },
      despesa_payroll_period_id:         { type: 'number',  required: false },
      despesa_generated_from_payroll:    { type: 'number',  required: false },
      despesa_generated_from_payroll_id: { type: 'number',  required: false },
      plano_conta_id:                    { type: 'number',  required: false },
    },
  },
})
